import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
    fill?: string
}

const XYIcon = React.forwardRef<SVGSVGElement, RefProps>(({ color = 'currentColor', size = 24, fill = 'black', ...rest }, ref) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="feather fill" ref={ref} {...rest}>
            <rect width="18" height="18" rx="2" ry="2" y="3" x="3"></rect>
            <circle cx="3" cy="3" r="2" className="fill-inverse"></circle>
            <circle cx="3" cy="21" r="2" className="fill-inverse"></circle>
            <circle cx="21" cy="21" r="2" className="fill-inverse"></circle>
            <circle cx="21" cy="3" r="2" className="fill-inverse"></circle>
        </svg>
    );
});

export default XYIcon;
